/* eslint-disable no-unused-vars */
import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import TeamSection from '../../components/TeamSection/TeamSection';
import Footer from '../../components/footer/Footer';
import Newslatter from '../../components/Newslatter/Newslatter';
import EventSection from '../../components/EventSection/EventSection';
import { useLanguage } from '../../i18n/LanguageContext';

const TeamPage =() => {
    const { t } = useLanguage();

    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={t('events.pageTitle')} pagesub={t('events.pageSubTitle')}/>
            
            <Newslatter/>
            <EventSection/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default TeamPage;
